import { Link, MailLetterCloseIcon, Text } from '@joinrepublic/dls-ui-kit';

import { useAnalytics } from '@r-client/shared/data/analytics';

import { HEADER_THEMES } from '../../types';
import { getTextColor } from '../../utils/get-text-color';
import { headerLinkStyles } from '../../utils/header-link-styles';

interface IMessagesMenuProps {
  unreadMessages?: number;
  theme: HEADER_THEMES;
}

export const MessagesMenu = ({ unreadMessages, theme }: IMessagesMenuProps) => {
  const analytics = useAnalytics();

  const trackMessagesIconClick = () => {
    analytics.track({
      name: 'header_icon_clicked',
      params: { label: 'messages', platform: 'web' },
    });
  };

  return unreadMessages ? (
    // The icon and the count badge are the link's only content, so without a name it reads as
    // empty (axe `link-name`, WCAG 2.4.4) — the same defect as its neighbours in the header.
    <Link
      {...headerLinkStyles}
      aria-label={`Messages, ${unreadMessages} unread`}
      href="/messages"
      position="relative"
      onClick={trackMessagesIconClick}
      data-testid="unread-messages-menu"
    >
      <MailLetterCloseIcon color={getTextColor(theme)} boxSize="6" />
      <Text
        as="span"
        size="body-300"
        color="white"
        position="absolute"
        bottom="-5px"
        right="-10px"
        textAlign="center"
        p="px"
        fontWeight="bold"
        background="red.500"
        borderRadius="xl"
        height="17px"
        width="22px"
        v="2.2"
      >
        {unreadMessages}
      </Text>
    </Link>
  ) : null;
};
